<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 厂商业务员管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			    @click="addBusinessPersons('addBusinessPersonsForm')"
			>添加账号</el-button>
		</div>
        <div class="container">
			<p class="filtrate_flex">
				<el-form ref="filtrateform" :model="filtrateform" class="filtrate_form">
						<el-form-item label="姓名"  prop='name'>
							<el-input v-model="filtrateform.name" style="width:200px"></el-input>
						</el-form-item>
				</el-form>	
				<el-button class="filtrate_btn" type="primary" icon="el-icon-search" @click="filtrateSearch(filtrateform)">搜索</el-button>
			</p>
            <el-table
                :data="listBusinessPersons"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="organizationName" label="机械厂商"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column prop="cellphoneNumber" label="电话"></el-table-column>
				<el-table-column prop="identityCards" label="身份证号码"></el-table-column>
                <!-- <el-table-column prop="statusStr" label="状态" align="center"></el-table-column> -->
				<el-table-column prop="statusStr" label="状态" align="center">
					<template slot-scope="scope">
						 <span v-if="scope.row.status == 1">
							 在职
						 </span>
						 <span v-else style="color: red;">
							 离职
						 </span>
					</template>
				</el-table-column>
				<el-table-column prop="permanentAddress" label="地址"></el-table-column>
				<el-table-column label="操作" width="100" align="center">
				    <template slot-scope="scope">
						<el-button
						    type="text"
						    icon="el-icon-edit"
						    @click="BusinessPersonsEdit(scope.row)"
						>编辑</el-button>
				        <!-- <el-button
				            type="text"
				            @click="manufacturerBusinessPersonEquit(scope.row)"
				        >离职</el-button> -->
				    </template>
				</el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<!-- 添加人员 -->
		<el-dialog class="branch-dialog" title="添加厂商业务员" :visible.sync="addBusinessPersonsVisible" width="600px">
		    <el-form ref="addBusinessPersonsForm" :model="addBusinessPersonsForm" :rules="addBusinessPersonsrules">
				<el-form-item label="机械厂商" prop="organizationId" class="select-box">
				    <el-select v-model="addBusinessPersonsForm.organizationId" placeholder="请选择机械厂商">
				      <el-option v-for="item in organselect" :label="item.name" :value="item.organizationId"></el-option>
				    </el-select>
				  </el-form-item>
				  <el-form-item label="姓名" prop="name">
				      <el-input v-model="addBusinessPersonsForm.name"></el-input>
				  </el-form-item>
		        <el-form-item label="电话" prop="cellphoneNumber">
		            <el-input v-model="addBusinessPersonsForm.cellphoneNumber"></el-input>
		        </el-form-item>
				<el-form-item label="地址" prop="areaAddress">
					<el-cascader :options="cityList" :props="optionProps" v-model="addBusinessPersonsForm.areaAddress" style="width: 100%;"></el-cascader>
					
				</el-form-item>
				<el-form-item prop="detailAddress">
					<el-input v-model="addBusinessPersonsForm.detailAddress"></el-input>
				</el-form-item>
				
				<el-form-item label="身份证号" prop="identityCards">
				    <el-input v-model="addBusinessPersonsForm.identityCards"></el-input>
				</el-form-item>
				
				<el-form-item label="状态">
				    <el-radio-group v-model="addBusinessPersonsForm.status">
				        <el-radio label="1">在职</el-radio>
				        <el-radio label="2">离职</el-radio>
				    </el-radio-group>
				</el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addBusinessPersonsbtn('addBusinessPersonsForm')">确 定</el-button>
		        <el-button @click="addBusinessPersonsVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
        <!-- 编辑弹出框 -->
        <el-dialog class="branch-dialog" title="编辑厂商业务员" :visible.sync="editBusinessPersonsVisible" width="600px">
            <el-form ref="editBusinessPersonsForm" :model="editBusinessPersonsForm" :rules="addBusinessPersonsrules">
        		<el-form-item label="机械厂商" prop="organizationId" class="select-box">
        		    <el-select v-model="editBusinessPersonsForm.organizationId" placeholder="请选择机械厂商">
        		      <el-option v-for="item in organselect" :label="item.name" :value="item.organizationId"></el-option>
        		    </el-select>
        		  </el-form-item>
        		  <el-form-item label="姓名" prop="name">
        		      <el-input v-model="editBusinessPersonsForm.name"></el-input>
        		  </el-form-item>
                <el-form-item label="电话" prop="cellphoneNumber">
                    <el-input v-model="editBusinessPersonsForm.cellphoneNumber"></el-input>
                </el-form-item>
        		<el-form-item label="地址" prop="areaAddress">
        			<el-cascader :options="cityList" :props="optionProps" v-model="editBusinessPersonsForm.areaAddress" style="width: 100%;"></el-cascader>
        			
        		</el-form-item>
        		<el-form-item prop="detailAddress">
        			<el-input v-model="editBusinessPersonsForm.detailAddress"></el-input>
        		</el-form-item>
        		
        		<el-form-item label="身份证号" prop="identityCards">
        		    <el-input v-model="editBusinessPersonsForm.identityCards"></el-input>
        		</el-form-item>
        		
        		<el-form-item label="状态">
        		    <el-radio-group v-model="editBusinessPersonsForm.status">
        		        <el-radio label="1">在职</el-radio>
        		        <el-radio label="2">离职</el-radio>
        		    </el-radio-group>
        		</el-form-item>
            </el-form>
        	
            <span slot="footer" class="dialog-footer">
        		<el-button type="primary" @click="editBusinessPersonsbtn('editBusinessPersonsForm')">确 定</el-button>
                <el-button @click="editBusinessPersonsVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>




<script>
import { listOrganizationComboVos,listProvinceCitys,listManufacturerBusinessPersons,saveManufacturerBusinessPerson,getManufacturerBusinessPerson,updateManufacturerBusinessPerson,quitManufacturerBusinessPerson} from '@/api/index';// 导入我们的api接口
export default {
    name: 'manufacturerbusinessperson',
    data() {
		  var validPhone = (rule, value, callback) => {
			  // debugger
		        const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
		        if (!value) {
		          return callback(new Error('电话号码不能为空'))
		        }else if(!Number.isInteger(+value)) {
		            callback(new Error('请输入数字值'))
		        } else {
		            if (phoneReg.test(value)) {
		              callback()
		         } else {
		              callback(new Error('电话号码格式不正确'))
		            }
		          }
		 };
		 var validIdNum = (rule, value, callback) => {
		   const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
		   if (!value) {
		     return callback(new Error('证件号码不能为空'))
		   } else if (!reg.test(value)) {
		     return callback(new Error('证件号码不正确'))
		   } else {
		     callback()
		   }
		 };
		  
        return {
			organselect:[],  //下拉
			cityList:[],//省市数据
			optionProps: {
				// TODO
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,
            listBusinessPersons: [],  //列表数据
			addBusinessPersonsForm:{
				organizationId:'',
				name:'',
				cellphoneNumber:'',
				areaAddress: [],  
				detailAddress:'',  
				identityCards:'',
				status:'1'
			},    //添加表单
			editBusinessPersonsForm:{
				
			},//编辑表单
			addBusinessPersonsrules: {
				organizationId: [
					{ required: true, message: '请选择机械厂商', trigger: 'change' }
				  ],
				  name:[
					  { required: true, message: '请输入用户名', trigger: 'blur' }
				  ],
				  cellphoneNumber:[
					{ required: true, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
				  ],
				   identityCards:[
				  	{ required: true, trigger: 'blur', validator: validIdNum }
				  ],
				 
				},  //添加表单验证
			
			addBusinessPersonsVisible:false,
			editBusinessPersonsVisible: false,
			
			filtrateform:{
				name:''
			},  //筛选
           
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistManufacturerBusinessPersons('');
		//省市
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		});
		
		// 机械厂商下拉
		listOrganizationComboVos({
			"kind": 4
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.organselect = res.data;
		})
		
    },
    methods: {
		// 列表数据
		getlistManufacturerBusinessPersons(){
			listManufacturerBusinessPersons({
				current: this.query.pageIndex,                    
				size: this.query.pageSize,
			    name:this.filtrateform.name
			}).then(res => {
				// 获取数据成功后的其他操作
				this.listBusinessPersons = res.data.records;
				this.pageTotal = res.data.total;
			});
		},
		// 筛选
		filtrateSearch(form){
			this.query.pageIndex = 1;
			this.filtrateform.name = form.name;
			this.getlistManufacturerBusinessPersons()
		},
		
		// 添加人员
		addBusinessPersons(formName){
			console.log(this.addBusinessPersonsForm)
			this.addBusinessPersonsVisible = true;
			//重置表单数据
			this.$nextTick(()=>{
			  this.$refs.[formName].resetFields();
			})
		},
		
		// 添加机构分支保存
		addBusinessPersonsbtn(formName){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  this.addBusinessPersonsForm.areaAddress = JSON.stringify(this.addBusinessPersonsForm.areaAddress);
				  delete this.addBusinessPersonsForm.checkPass;
				  saveManufacturerBusinessPerson(this.addBusinessPersonsForm).then(res => {
					  this.query.pageIndex = 1;
					  //重置表单数据
					  this.$nextTick(()=>{
					    this.$refs.['filtrateform'].resetFields();
					  })
					  this.filtrateform.name = '';
					  this.getlistManufacturerBusinessPersons();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.addBusinessPersonsVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
			
			
		},
		
		
       
        // 删除操作
        manufacturerBusinessPersonEquit(row) {
			if(row.status == 1){
				// 二次确认删除
				this.$confirm('确定要修改状态吗？', '提示', {
				    type: 'warning'
				}).then(() => {
					quitManufacturerBusinessPerson({},{
						 "personId": row.personId          
					}).then(res => {
						this.getlistManufacturerBusinessPersons();
						if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
						}else if(res.code == 1){
							  this.$message({
								message: res.message,
								type: 'warning'
							  });
						}else{
							  this.$message({
								message: '报错啦!',
								type: 'warning'
							  });
						}
						
					});
				}).catch(() => {});
			}else{
				this.$confirm('已经是离职状态!', '提示', {
				    type: 'warning'
				}).then(() => {
					
				}).catch(() => {});
			}
           
        },
       
        // 点击编辑操作
        BusinessPersonsEdit(row) {
			getManufacturerBusinessPerson({},{
					 "personId": row.personId,
				     "organizationId": row.organizationId
				}).then(res => {
					this.editBusinessPersonsForm = res.data;
					if(typeof(this.editBusinessPersonsForm.areaAddress) == "string"){
						this.editBusinessPersonsForm.areaAddress = JSON.parse(this.editBusinessPersonsForm.areaAddress);	
					}
					if(typeof(this.editBusinessPersonsForm.status) == 'number'){
						this.editBusinessPersonsForm.status = this.editBusinessPersonsForm.status+'';	
					}
				});
			   this.editBusinessPersonsVisible = true;
        },
        // 保存编辑
        editBusinessPersonsbtn(formName) {
            this.$refs[formName].validate((valid) => {
              if (valid) {
            	  // 负责区域字段格式处理
            	  this.editBusinessPersonsForm.areaAddress = JSON.stringify(this.editBusinessPersonsForm.areaAddress);
            	  
            	  updateManufacturerBusinessPerson(this.editBusinessPersonsForm).then(res => {
            		  this.getlistManufacturerBusinessPersons();
            		  if(res.code == 0){
            			  // 获取数据成功后的其他操作
            				this.$message({
            				  message: res.message,
            				  type: 'success'
            				});
            				this.editBusinessPersonsVisible = false;
            		  }else if(res.code == 1){
            			  this.$message({
            			    message: res.message,
            			    type: 'warning'
            			  });
            		  }else{
            			  this.$message({
            			    message: '报错啦!',
            			    type: 'warning'
            			  });
            		  }
            		   
            	  });
              } else {
            	return false;
              }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistManufacturerBusinessPersons();
        }
    }
};
</script>

<style scoped>
	/* 筛选 */
	.filtrate_flex{
		display: flex;
		display: -webkit-flex;
		}
	.filtrate_form{
		width: 300px;
	}
	
	.filtrate_btn{
		width: 100px;
		height: 32px;
	}
	
	
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}




</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	width: 100px;
}
.filtrate_form .el-form-item__label{
		font-size: 16px;
	}
.branch-dialog .el-form-item__content{
	margin-left: 100px;
}
/* .branch-area .el-form-item__content{
	margin-top: 30px;
} */
.branch-area{
	text-align: right;
}
.branch-area i{
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem {
	position: relative;
	margin-top: 10px;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.select-box .el-select {
	width: 100%;
}
</style>
